import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import LookbookPacifico from './pages/LookbookPacifico';
import LookbookAltamar from './pages/LookbookAltamar';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/lookbookpacifico" element={<LookbookPacifico />} />
        <Route path="/altamar/:id" element={<LookbookAltamar />} />
      </Routes>
    </Router>
  );
}

// Made with Bob
